const patientSchema = {
  feilds: [
    {
      id: 0,
      name: "search",
      text: "Search",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Search",
      icon: "search",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Your Userid",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
  ],
};

const tokenSchema = {
  feilds: [
    {
      name: "tokenType",
      label: "Token Type",
      placeholder: "Select Token Type",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      state: "",
      relation: false,
      relationvalue: [],
      mode: "group",
      disable: true,
      value: null,
      type: "radio",
      styles: { cols: "col-12 mb-3 mt-2" },
      groupData: [
        {
          name: "normal",
          label: "Normal",
          placeholder: "Select",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "radio",
          disable: false,
          value: null,
        },
        {
          name: "emergency",
          label: "Emergency",
          placeholder: "Select",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "radio",
          disable: false,
          value: null,
        },
      ],
    },
    {
      name: "serviceType",
      label: "Service Type",
      placeholder: "Select Service",
      icon: null,
      rules: [],
      errors: [],
      valid: false,
      state: "",
      relation: false,
      relationvalue: [],
      mode: "group",
      disable: true,
      value: null,
      type: "radio",
      styles: { cols: "col-12 mb-3 mt-2" },
      groupData: [
        {
          name: "newRegistration",
          label: "New Registration",
          placeholder: "Select",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "radio",
          disable: false,
          value: null,
        },
        {
          name: "billing",
          label: "Billing",
          placeholder: "Select",
          icon: null,
          rules: [],
          errors: [],
          valid: false,
          state: "",
          mode: "single",
          type: "radio",
          disable: false,
          value: null,
        },
      ],
    },
    {
      name: "enter phone no",
      label: "Enter Phone Number",
      placeholder: "Enter mobile number",
      icon: null,
      type: "input",
      required: true,
      mode: "single",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Mobile Number",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      visiable: true,
    },
  ],
};

export { patientSchema, tokenSchema };
